"use client";

import { useEffect, useState } from "react";
import {
  getUserStoreHasHydrated,
  subscribeUserStoreHydration,
} from "@/global-store/user";

/** True after zustand persist has restored user from localStorage. */
export const useUserStoreHydrated = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const markHydrated = () => setHydrated(true);

    if (getUserStoreHasHydrated()) {
      markHydrated();
      return undefined;
    }

    const unsub = subscribeUserStoreHydration(markHydrated);
    // Rehydration may finish before this effect runs
    queueMicrotask(() => {
      if (getUserStoreHasHydrated()) {
        markHydrated();
      }
    });

    return unsub;
  }, []);

  return hydrated;
};
